import { c as _c } from "react/compiler-runtime";
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TrackingProps, TrackingStorageState } from './use-tracking-storage.types';
import { defaultTracking } from './use-tracking-storage.types';
export const useStore = create<TrackingStorageState>()(persist(set => ({
  data: defaultTracking,
  reset: () => set({
    data: defaultTracking
  }),
  update: (data: Partial<TrackingProps>) => {
    set(oldTracking => ({
      ...oldTracking,
      data: {
        ...oldTracking.data,
        ...data
      }
    }));
  }
}), {
  version: 1,
  name: 'tracking-session-storage'
}));
const useTrackingStorage = () => {
  const $ = _c(4);
  const {
    data,
    reset,
    update
  } = useStore(_temp);
  let t0;
  if ($[0] !== data || $[1] !== reset || $[2] !== update) {
    t0 = {
      data,
      reset,
      update
    };
    $[0] = data;
    $[1] = reset;
    $[2] = update;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default useTrackingStorage;
function _temp(state) {
  return state;
}